import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { IKnowledgeTrail } from '../../features/knowledge-trail/types';
import { getKnowledgeTrails } from '../../features/knowledge-trail/api';
import { KnowledgeTrailContentView } from '../../features/knowledge-trail/components/KnowledgeTrailContentView/KnowledgeTrailContentView';
import { useAuth } from '../../hooks/useAuth';
import { Loading } from '../../components/Loading';

export function KnowledgeTrailContent() {
  const { trailId, contentIndex } = useParams<{
    trailId: string;
    contentIndex: string;
  }>();
  const { client, player } = useAuth();
  const location = useLocation();
  const stateTrail = (location.state as { trail: IKnowledgeTrail })?.trail;
  const [trail, setTrail] = useState<IKnowledgeTrail | null>(stateTrail);

  useEffect(() => {
    async function fetchTrail() {
      if (!client?.id || !player?.id) return;
      try {
        const trails = await getKnowledgeTrails(client.id, player.id);
        const found = trails.find((t) => t.id === trailId);
        if (found) setTrail(found);
      } catch (error) {
        console.error('Error fetching knowledge trail:', error);
      }
    }
    fetchTrail();
  }, [trailId, client?.id, player?.id]);

  if (!trail) {
    return <Loading />;
  }

  const index = Number(contentIndex);
  const content = trail.content[index];

  if (!content) {
    return <div className="container my-3">Conteúdo não encontrado.</div>;
  }

  return (
    <KnowledgeTrailContentView
      content={content}
      contentIndex={index}
      courseBookUrl={trail.courseBookUrl}
      trail={trail}
    />
  );
}
